import React, { useState, useEffect, useCallback, useMemo  } from "react";
import "./Home.css";
import "bootstrap/dist/css/bootstrap.css"; // Import Bootstrap CSS
import Contact from "./Contact"; // Import the Contact component

import image1 from "./images/Building-Talent-Web-Image-UEI.webp";
import image2 from "./images/Electrical-Engineering-Technology-gtc12.png";
import image3 from "./images/residential-electrical-outlet-install-640x480.jpg";
import image4 from "./images/new-home-electrical-wiring.jpg";
import image5 from "./images/emmanuel-ikwuegbu-_2AlIm-F6pw-unsplash.jpg";
import DivisionCards from "./DivisionCards";


const Home = () => {
  const images = useMemo(() => [image1, image2, image3, image4, image5], []);

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  }, [images]);

  const goToPrevImage = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  }, [images]);

  useEffect(() => {
    // Auto scroll to the next image every 5 seconds (5000 milliseconds)
    const intervalId = setInterval(nextImage, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [nextImage]);

  return (
    <div>
      <div className="container">
        <div
          className="jumbotron hero-section section"
          style={{
            backgroundImage: `url(${images[currentIndex]})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "100vh",
          }}
        >
          <div className="hero-content" style={{ padding: "20px" }}>
            <address
              style={{
                background: "rgba(0, 0, 0, 0.7)",
                padding: "10px",
                borderRadius: "5px",
                textAlign: "center",
              }}
            >
              <h1 className="display-4">Welcome to Mustang Electric, LLC</h1>
              <p className="lead">
                Your trusted partner for electrical services.
              </p>
              <p>At Mustang Electric, LLC, we take pride in offering a comprehensive range of top-quality electrical services tailored to meet the unique needs of homeowners. Our dedicated team of experienced professionals is here to empower you with reliable solutions for your electrical requirements. Whether you're in need of electrical wiring installations, panel upgrades, or other essential electrical services, we've got you covered</p>
            </address>
          </div>
          <div className="pagination-dots">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${currentIndex === index ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
              ></span>
            ))}
          </div>
          <div className="image-navigation">
            <button onClick={goToPrevImage}>Previous</button>
            <button onClick={nextImage}>Next</button>
          </div>
        </div>

        <div
          className="jumbotron section"
          style={{
            background: "gold",
            padding: "20px",
            borderRadius: "5px",
            color: "blue",
            textAlign: "center",
          }}
        >
          <h2>Our Mission</h2>
          <p>
            At Mustang Electric, LLC, we are dedicated to providing top-quality
            electrical services to power your world. Our mission is to deliver
            excellence, safety, and innovation in every project, lighting the
            path towards a brighter and more electrifying future.
          </p>
        </div>

        <div
          className="jumbotron section"
          style={{
            background: "#135299",
            padding: "20px",
            borderRadius: "5px",
            color: "white",
            textAlign: "center",
          }}
        >
          <h2>Electric Services: Commercial and Residential</h2>
          <p>
            We offer a wide range of electrical services, both for residential
            and commercial clients.
          </p>
          <a href="/about" className="btn btn-primary mx-auto">
            Learn More
          </a>
        </div>

        <div
          className="jumbotron gallery section"
          style={{
            background: "gold",
            padding: "20px",
            borderRadius: "5px",
            color: "white",
            textAlign: "center",
          }}
        >
          <div className="row">
            <div className="col-lg-3 col-md-4 col-sm-6">
              <img
                src={image2}
                alt="Commercial electrical services by Mustang Electric, LLC"
              />
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <img
                src={image3}
                alt="Our team working on an electrical project"
              />
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <img
                src={image4}
                alt="New home electrical wiring by Mustang Electric, LLC"
              />
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <img src={image5} alt="emnanny 5" />
            </div>
          </div>
        </div>

        <div
          className="jumbotron section"
          style={{
            background: "#135299",
            padding: "20px",
            borderRadius: "5px",
            color: "white",
            textAlign: "center",
          }}
          
        >
          <DivisionCards />
          <h2>Contact Us</h2>
          <p>
            If you have any questions or need assistance, feel free to contact us.
          </p>
          <div
            style={{
              background: "#135299",
              padding: "20px",
              borderRadius: "5px",
              textAlign: "center",
            }}
          >
            
            <Contact /> {/* Add the Contact component here */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;







